<template>
  <div id="wap">
    <img src="https://shared-https.ydstatic.com/dict/market/webTransPc/images/youdaodictlogo.png" alt="" class="logo">
    <p>网页翻译全面升级 · 体验更快更准</p>
    <img src="https://shared-https.ydstatic.com/dict/market/webTransPc/images/pic.png" alt="" class="banner">
    <div class="open_dict">
      <div class="open" @click="openDict">一键打开</div>
    </div>
    <div class="dialog" v-if="goToBrowser">
      <div class="mask"></div>
      <img src="https://shared-https.ydstatic.com/dict/market/webTransPc/images/share.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "Clause",
  data() {
    return {
      goToBrowser: false
    };
  },
  methods: {
    openDict: function() {
      let phone;
      let u = navigator.userAgent;
      // android终端
      let phoneIsAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      // ios终端
      let phoneIsIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (phoneIsAndroid) {
        phone = "andr";
      } else if (phoneIsIos) {
        phone = "ios";
      }
      // 微信浏览器
      let uaWX = u.toLowerCase().includes("micromessenger");
      // 微博浏览器
      let uaWB = u.toLowerCase().includes("weibo");
      if (uaWX || uaWB) {
        window.location.href = `https://c.youdao.com/dict/download.html`;
      }
      if (phone === "andr") {
        // 跳转到app里面
        window.location.href = `yddict://youdao.com`;
        var loadTimer = setTimeout(() => {
          if (document.hidden || document.webkitHidden) {
            return;
          }
          window.location.href = `https://c.youdao.com/dict/download.html`;
        }, 2000);
        var visibilitychange = function() {
          var tag = document.hidden || document.webkitHidden;
          tag && clearTimeout(loadTimer);
        };
        document.addEventListener( "visibilitychange", visibilitychange, false);
        document.addEventListener( "webkitvisibilitychange", visibilitychange, false );
        window.addEventListener( "pagehide", () => { clearTimeout(loadTimer);}, false );
      } else if (phone === "ios") {
        location.href = "https://c.youdao.com/dict/download.html"
      }
    }
  }
};
</script>

<style scoped>
#wap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(246, 247, 250, 1);
}
.logo {
  width: 4.7rem;
  height: 1.48rem;
  display: block;
  margin: 0.51rem auto 0.16rem;
}
#wap p {
  width: 100%;
  height: 0.48rem;
  font-size: 0.34rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(49, 55, 85, 1);
  line-height: 0.48rem;
  text-align: center;
  margin-bottom: 0.56rem;
}
.banner {
  width: 5.15rem;
  height: 6.16rem;
  display: block;
  margin: 0 auto 1.68rem;
}
.open_dict {
  height: 1.68rem;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(246, 247, 250, 1);
  box-shadow: 0 0 0.24rem 0 rgba(81, 85, 99, 0.1);
}
.open_dict .open {
  width: 6.54rem;
  height: 0.88rem;
  background: rgba(224, 0, 18, 1);
  border-radius: 0.03rem;
  font-size: 0.36rem;
  font-weight: bold;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 0.88rem;
  margin: 0.4rem auto;
  text-align: center;
}
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
}
.dialog img {
  width: 4.7rem;
  height: 2.6rem;
  position: fixed;
  top: 0;
  right: 0;
}
/* 兼容iPhonex */
@media (device-width: 375px) and (device-height: 812px) and (-webkit-min-device-pixel-ratio: 3) {
  .open_dict {
    height: 2.02rem;
  }
}
/* 兼容iPhone XS、XR*/
@media (device-width: 414px) and (device-height: 896px) and (-webkit-min-device-pixel-ratio: 2) {
  .open_dict {
    height: 2.02rem;
  }
}
</style>
